import React from 'react';
import "./ListLibraryNode.css";
import {Button, ButtonGroup, ButtonToolbar} from "reactstrap";
import TextLabel from "../../controls/TextLabel.mjs";
import EditIcon from "../../media/images/EditIcon.mjs";
import TrashIcon from "../../media/images/TrashIcon.mjs";
import HamburgerArea from "../../controls/HamburgerArea.mjs";
import ModalEditLibraryNode from "../modals/ModalEditLibraryNode.mjs";
import ChevronUpIcon from "../../media/images/ChevronUpIcon.mjs";
import ChevronDownIcon from "../../media/images/ChevronDownIcon.mjs";
import ModalEditLibraryLeaf from "../modals/ModalEditLibraryLeaf.mjs";
import G from "../../libs/Glob.mjs";
import MyLibraryIcon from "../../media/images/MyLibraryIcon.mjs";
import MyRemediationIcon from "../../media/images/MyRemediationIcon.mjs";
import MyNoteIcon from "../../media/images/MyNoteIcon.mjs";
import MyLeafIcon from "../../media/images/MyLeafIcon.mjs";
import MyNodeIcon from "../../media/images/MyNodeIcon.mjs";
import MyControlIcon from "../../media/images/MyControlIcon.mjs";
import MyAssetIcon from "../../media/images/MyAssetIcon.mjs";

const prefix = 'ListLibraryNode';

/**
 * @typedef LibraryNodeListProps
 * @type {Object}
 * @property {AthenaNodeHelperObject} fh
 * @property {AthenaNodeHelperObject} [parent]
 * @property {function} onChange
 */

/**
 * @typedef LibraryNodeListState
 * @type {Object}
 * @property {AthenaLibNode} data Raw node data
 * @property {boolean} hasLeaf
 * @property {boolean} isLeaf
 * @property {boolean} [hasSubnodes]
 * @property {boolean} [dontDelete]
 * @property {boolean|string} [onEdit]
 * @property {string} [className]
 * @property {number} lastUpdate
 */

const ListLibraryNode = class extends React.Component {
	/**
	 * @param {LibraryNodeListProps} props
	 */
	constructor(props) {
		super(props);
		/** @type {LibraryNodeListState} */
		this.state = {
			data: props.fh.getData(),
			hasLeaf: this.props.fh.hasLeaf(),
			isLeaf: this.props.fh.isLeaf(),
			lastUpdate: Date.now()
		}
		if ( ! this.state.data._ ) this.state.data._ = {};
		this.state.hasSubnodes = ( this.state.data.children && this.state.data.children.length > 0 && ! this.state.hasLeaf );
		this.state.className = this.state.hasLeaf ? 'hasLeaf' : (this.state.isLeaf ? 'isLeaf' : '');
		this.nodeLabel = this.nodeLabel.bind(this);
		this.icon = this.icon.bind(this);
		this.nodeButtons = this.nodeButtons.bind(this);
		this.editButtons = this.editButtons.bind(this);
		this.quickButtons = this.quickButtons.bind(this);
		this.editor = this.editor.bind(this);
		this.save = this.save.bind(this);
		this.getPref = this.getPref.bind(this);
		this.setPref = this.setPref.bind(this);
	}

	getPref( name ) {
		return this.state.data._[name];
	}

	setPref( name, value ) {
		const d = this.state.data;
		if ( typeof value === 'undefined' ) {
			delete d._[name];
		} else {
			d._[name] = value;
		}
		this.setState({ data: d }, ()=>{
			this.props.onChange( this.state.data );
		});
	}

	save( data ) {
		const ns = { lastUpdate: Date.now() };
		if ( typeof data === 'undefined' ) {
			data = this.state.data;
		} else {
			ns.data = data;
		}
		this.props.onChange( data );
		setTimeout( ()=>{
			ns.hasLeaf = this.props.fh.hasLeaf();
			ns.isLeaf = this.props.fh.isLeaf();
			this.setState(ns);
		});
	}

	editButtons() {
		return(
			<>
				<ButtonGroup className="btn-icon" vertical={true}>
					<Button
						color={"primary"}
						onClick={() => {
							this.setState({onEdit: true})
						}}
					>
						<b>
							<TextLabel value={"Edit"}/>
						</b>
						<i>
							<EditIcon/>
						</i>
					</Button>
				</ButtonGroup>
				{ this.state.dontDelete || (
					<ButtonGroup className="btn-icon" vertical={true}>
						<Button
							color={"danger"}
							onClick={ ()=> {
								if ( ! window.confirm(G.label('RemoveWarning',{item:`«${this.props.fh.getName()}»`}))) return;
								const pd = this.props.parent.getData();
								pd.children.splice( this.props.fh.getIndex(), 1);
								this.props.parentSave( pd );
							}}
						>
							<b>
								<TextLabel value={"Remove"}/>
							</b>
							<i>
								<TrashIcon/>
							</i>
						</Button>
					</ButtonGroup>
				)}
			</>
		)
	}

	editor() {
		if ( ! this.state.onEdit ) return '';
		const languages = this.props.fh.root().getField('languages');
		if ( this.state.onEdit === 'newNode') {
			return(
				<ModalEditLibraryNode
					data={ {} }
					languages={ languages }
					cancel={ ()=>{ this.setState({ onEdit: false }) }}
					save={ d => {
						this.setState({ onEdit: false }, ()=>{
							const wd = this.state.data;
							if ( ! wd.children ) wd.children = [];
							wd.children.push(d);
							this.save(wd);
						});
					} }
				/>
			);
		}
		if ( this.state.onEdit === 'newLeaf') {
			return(
				<ModalEditLibraryLeaf
					data={ {} }
					languages={ languages }
					cancel={ ()=>{ this.setState({ onEdit: false }) }}
					save={ d => {
						this.setState({ onEdit: false }, ()=>{
							const wd = this.state.data;
							if ( ! wd.children ) wd.children = [];
							wd.children.push(d);
							this.save(wd);
						});
					} }
				/>
			);
		}
		if ( this.state.onEdit === true ) {
			if ( this.state.isLeaf ) {
				return(
					<ModalEditLibraryLeaf
						data={ this.state.data }
						languages={ languages }
						cancel={ ()=>{ this.setState({ onEdit: false }) }}
						save={ d => {
							this.setState({ onEdit: false }, ()=>{
								this.save(d);
							});
						} }
					/>
				);
			} else {
				return(
					<ModalEditLibraryNode
						data={ this.state.data }
						languages={ languages }
						cancel={ ()=>{ this.setState({ onEdit: false }) }}
						save={ d => {
							this.setState({ onEdit: false }, ()=>{
								this.save(d);
							});
						} }
					/>
				);
			}
		}
		return '';
	}

	nodeButtons() {
		if ( this.state.isLeaf ) return '';
		return(
			<ButtonGroup className="btn-icon" vertical={true}>
				{ this.state.hasLeaf || (
					<Button
						onClick={() => {
							this.setState({onEdit: 'newNode'});
						}}
					>
						<b>
							<TextLabel value={"New group"}/>
						</b>
						<i>
							<MyNodeIcon/>
						</i>
					</Button>
				)}
				{this.state.hasSubnodes || (
					<Button
						onClick={() => {
							this.setState({onEdit: 'newLeaf'});
						}}
					>
						<b>
							<TextLabel value={"New leaf"}/>
						</b>
						<i>
							<MyLeafIcon/>
						</i>
					</Button>
				)}
			</ButtonGroup>
		);
	}

	quickButtons() {
		const len = this.props.parent ? this.props.parent?.children()?.length : 0;
		const idx = this.props.fh.getIndex();
		const out = [];
		if ( len > 1 ) {
			out.push(
				<ButtonGroup
					key={"move"}
					className={"btn-icon"}
				>
					<Button
						disabled={ idx === 0 }
						onClick={ ()=>{
							const wd = this.props.parent.getData();
							const a = wd.children[idx];
							wd.children[idx] = wd.children[idx-1];
							wd.children[idx-1] = a;
							this.props.parentSave(wd);
						}}
					>
						<i>
							<ChevronUpIcon/>
						</i>
					</Button>
					<Button
						disabled={ (idx +1) >= len }
						onClick={ ()=>{
							const wd = this.props.parent.getData();
							const a = wd.children[idx];
							wd.children[idx] = wd.children[idx+1];
							wd.children[idx+1] = a;
							this.props.parentSave(wd);
						}}
					>
						<i>
							<ChevronDownIcon />
						</i>
					</Button>
				</ButtonGroup>
			);
		}
		return(
			<ButtonToolbar className="quick-buttons">
				{ out }
				<ButtonGroup
					key={"quick"}
					className={"btn-icon"}
				>
					<Button
						color={"primary"}
						onClick={ ()=>{ this.setState({onEdit: true }) }}
					>
						<i>
							<EditIcon />
						</i>
					</Button>
				</ButtonGroup>
			</ButtonToolbar>
		)
	}

	icon() {
		if ( this.state.isLeaf ) {
			return (
				<span className={"icon"}>
					<MyLeafIcon/>
				</span>
			)
		}
		if ( ! this.props.parent ) {
			return (
				<span className={"icon"}>
					<MyLibraryIcon />
				</span>
			)
		}
		if ( this.state.hasLeaf ) {
			return (
				<span
					className={"icon collapsible"+( this.state.data?._?.collapsed ? ' collapsed' : '' )}
					onClick={ (e)=>{
						e.stopPropagation();
						e.preventDefault();
						this.setPref('collapsed', ! this.getPref('collapsed') );
					}}
				>
					<MyControlIcon/>
				</span>
			)
		}
		return (
			<span
				className={"icon collapsible"+( this.state.data?._?.collapsed ? ' collapsed' : '' )}
				onClick={ (e)=>{
					e.stopPropagation();
					e.preventDefault();
					this.setPref('collapsed', ! this.getPref('collapsed') );
				}}
			>
				<MyNodeIcon/>
			</span>
		)
	}

	nodeLabel() {
		return (
			<>
				{this.icon()}
				<span className={"code"}>
					{this.props.fh.showCode()}
				</span>
				<span className={"name"}>
					{this.props.fh.getName()}
				</span>
				{this.state.data.asset && (
					<span className={"icon"} title={G.label('Asset')}>
						<MyAssetIcon/>
					</span>
				)}
				{this.state.data.note && (
					<span className={"icon"} title={G.label('Note')}>
						<MyNoteIcon/>
					</span>
				)}
				{this.state.data.remediation && (
					<span className={"icon"} title={G.label('Remediation')}>
						<MyRemediationIcon/>
					</span>
				)}
			</>
		);
	}

	render() {
		return (
			<div className={prefix + ' ' + this.state.className}>
				<div>
					<div
						className={"label"}
						onDoubleClick={ ()=>{ this.setState({onEdit: true}) }}
					>
						{this.nodeLabel()}
					</div>
					<div className={"controls"}>
						{this.quickButtons()}
						<div className={"hamburger"}>
							<HamburgerArea align={"end"}>
								<ButtonToolbar className={prefix + 'Toolbar'}>
									{this.editButtons()}
									{this.nodeButtons()}
								</ButtonToolbar>
							</HamburgerArea>
						</div>
					</div>
				</div>
				{ ! this.state.data?._?.collapsed && this.state.data?.children && this.props.fh.children() && (this.props.fh.children().length > 0 ) && (
					<blockquote key={this.state.lastUpdate}>
						{this.props.fh.children().map((snh, i) => (
							<ListLibraryNode
								key={i}
								fh={snh}
								parent={this.props.fh}
								parentSave={ this.save }
								onChange={ d =>{
									const wd = this.state.data;
									wd.children[i] = d;
									this.save(wd);
								}}
							/>
						))}
					</blockquote>
				)}
				{ this.state.onEdit && this.editor() }
			</div>
		)
	}
}

export default ListLibraryNode;
